$shm_ba_summary $mol_view
	table null
	selected? \Сообщений
	sort? \Дата
	sort_order? \desc
	page? 0
	pick*? null
	sub <= cards /
	Card* $shm_ba_summary_card
		title <= card_title* \
		value <= card_value* \
		selected <= card_selected* false
		click? <=> pick*? null
